import { frameworkIdentifier, frameworkIdentifierFormatter } from "./identifier.js";
import { nextJsFormatters } from "./formatters.client.js";
export {
  frameworkIdentifier,
  frameworkIdentifierFormatter,
  nextJsFormatters
};
//# sourceMappingURL=index.client.js.map
